export default {
  methods: {
    hi: function(name){
      return "你好, " + name;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/common_hi.js